import React, { useEffect, useState } from 'react'
import {
  DatePicker,
} from 'antd'
import classnames from 'classnames'
import moment from 'moment'

import styles from './index.less'

const {
  RangePicker,
} = DatePicker

enum ShortCut {
  TODAY = "今",
  YESTERDAY = "昨",
  NOW_MONTH = "当月",
  NOW_DAY_MONTH = "当月 ",
  LAST_WEEK = "近7天",
  LAST_MONTH = "近30天",
  LAST_THREE_MONTH = "近90天"
}

function RangeSelect(props: any) {
  const {
    value,
    onChange,
    startName,
    endName,
    isFlag,
    isBtn, // 判断是否展示 ShortCut 按钮
    isThreeMonth, // 判断是否展示 '近90天'按钮
    isNowMonth, // 判断是否展示 '当月'按钮
    isNowDayMonth, // 判断是否展示 '当月'按钮，该当月包含当天
    statictime,
    placeholder = ['开始日期', '结束日期'],
    setDisabled = false,
    maxDate,
    disabled = false,
    disabledDayNum = '',
    specialStyle = {},
    allowClear = true,
  } = props

  const [dates, setDates] = useState([]);
  const [hackValue, setHackValue] = useState<any>();
  const disabledDate = current => {
    if (maxDate) {
      if (!dates || dates.length === 0) {
        return false;
      }
      const tooLate = dates[0] && current.diff(dates[0], 'days') > maxDate;
      const tooEarly = dates[1] && dates[1].diff(current, 'days') > maxDate;
      return tooEarly || tooLate;
      // if (current && current < moment().endOf('day')) {
      //   if (!dates || dates.length === 0) {
      //     return false;
      //   }
      //   const tooLate = dates[0] && current.diff(dates[0], 'days') > 30;
      //   const tooEarly = dates[1] && dates[1].diff(current, 'days') > 30;
      //   return tooEarly || tooLate;
      // } else {
      //   return true
      // }
    } else {
      if (!dates || dates.length === 0) {
        return false;
      }
      const tooLate = dates[0] && current.diff(dates[0], 'days') > 30;
      const tooEarly = dates[1] && dates[1].diff(current, 'days') > 30;
      return tooEarly || tooLate;
    }
  };
  const disabledDayDate = current => {
    return current && current.isAfter(moment().subtract(disabledDayNum, 'days'))
  }

  const onOpenChange = open => {
    if (open) {
      setHackValue([]);
      setDates([]);
    } else {
      setHackValue(undefined);
    }
  };

  function handleChange(val) {
    const start = val?.[0]
    const end = val?.[1]

    if (start && end) {
      // 取当天 0 点 / 23:59:59.999 直接用 moment，禁止绕道 toLocaleDateString()
      // —— 它的输出格式跟随系统区域（zh-HK/en-GB/de 等给出 17/8/2026 这类），
      // new Date() 解析回来是 Invalid Date → NaN，日期选完直接回显为空（macOS 实测偶发）
      const startTime = start.clone().startOf('day').valueOf()
      const endTime = end.clone().endOf('day').valueOf()
      onChange({
        [startName]: startTime,
        [endName]: endTime
      })
    } else {
      onChange(undefined)
    }
  }

  function getTimeDistance(type: ShortCut): any {
    switch (type) {
      case ShortCut.TODAY:
        return [moment().hour(0).minute(0).seconds(0).milliseconds(0), moment().hour(23).minute(59).seconds(59).milliseconds(999)];
      case ShortCut.YESTERDAY:
        return [moment().subtract(1, 'd').hour(0).minute(0).seconds(0).milliseconds(0), moment().subtract(1, 'd').hour(23).minute(59).seconds(59).milliseconds(999)];
      case ShortCut.NOW_MONTH:
        return [moment().startOf('month').hour(0).minute(0).seconds(0).milliseconds(0), moment().subtract(1, 'd').hour(23).minute(59).seconds(59).milliseconds(999)];
      case ShortCut.NOW_DAY_MONTH:
        return [moment().startOf('month').hour(0).minute(0).seconds(0).milliseconds(0), moment().hour(23).minute(59).seconds(59).milliseconds(999)];
      case ShortCut.LAST_WEEK:
        return [moment().subtract(6, 'd').hour(0).minute(0).seconds(0).milliseconds(0), moment().hour(23).minute(59).seconds(59).milliseconds(999)];
      case ShortCut.LAST_MONTH:
        return [moment().subtract(29, 'd').hour(0).minute(0).seconds(0).milliseconds(0), moment().hour(23).minute(59).seconds(59).milliseconds(999)];
      case ShortCut.LAST_THREE_MONTH:
        return [moment().subtract(89, 'd').hour(0).minute(0).seconds(0).milliseconds(0), moment().hour(23).minute(59).seconds(59).milliseconds(999)];
    }
  }

  function isActive(type: ShortCut) {
    if (!value) {
      return '';
    }

    if (!value[startName] || !value[endName]) {
      return '';
    }

    const td = getTimeDistance(type);

    if (!td) {
      return '';
    }

    if (
      moment(value[startName]).isSame(td[0], 'day') &&
      moment(value[endName]).isSame(td[1], 'day')
    ) {
      return styles.active;
    }

    return '';
  }

  function selectDate(type: ShortCut) {
    return () => {
      const val = getTimeDistance(type)
      handleChange(val)
    }
  }

  function transformValue(obj): any {
    if (obj?.[startName] && obj?.[endName]) return [moment(obj[startName]), moment(obj[endName])]

    return []
  }

  return (
    <div className={styles.container}>
      <RangePicker
        format='YYYY.MM.DD'
        className={styles.rangePicker}
        value={(setDisabled ? hackValue : false) || transformValue(value || statictime)}
        onChange={handleChange}
        placeholder={placeholder}
        onOpenChange={setDisabled ? onOpenChange : null}
        disabledDate={setDisabled ? disabledDate : (disabledDayNum ? disabledDayDate : null)}
        onCalendarChange={setDisabled ? val => setDates(val) : null}
        // getPopupContainer={(triggerNode:any) => triggerNode.parentNode}
        style={{...specialStyle}}
        disabled={disabled}
        allowClear={allowClear}
      />
      {
        isBtn ? null : <>
          {
            isFlag ? null : <span onClick={selectDate(ShortCut.TODAY)} className={classnames(styles.shortcut, isActive(ShortCut.TODAY))}>{ShortCut.TODAY}</span>
          }
          <span onClick={selectDate(ShortCut.YESTERDAY)} className={classnames(styles.shortcut, isActive(ShortCut.YESTERDAY))}>{ShortCut.YESTERDAY}</span>
          {
            isNowMonth && new Date().getDate() != 1 ? <span onClick={selectDate(ShortCut.NOW_MONTH)} className={classnames(styles.shortcut, isActive(ShortCut.NOW_MONTH))}>{ShortCut.NOW_MONTH}</span> : null
          }
          {
            isNowDayMonth ? <span onClick={selectDate(ShortCut.NOW_DAY_MONTH)} className={classnames(styles.shortcut, isActive(ShortCut.NOW_DAY_MONTH))}>{ShortCut.NOW_DAY_MONTH}</span> : null
          }
          <span onClick={selectDate(ShortCut.LAST_WEEK)} className={classnames(styles.shortcut, isActive(ShortCut.LAST_WEEK))}>{ShortCut.LAST_WEEK}</span>
          <span onClick={selectDate(ShortCut.LAST_MONTH)} className={classnames(styles.shortcut, isActive(ShortCut.LAST_MONTH))}>{ShortCut.LAST_MONTH}</span>
          {
            isThreeMonth ? <span onClick={selectDate(ShortCut.LAST_THREE_MONTH)} className={classnames(styles.shortcut, isActive(ShortCut.LAST_THREE_MONTH))}>{ShortCut.LAST_THREE_MONTH}</span> : null
          }
        </>
      }
    </div>
  );
}

export default RangeSelect
